import { Component, Output, EventEmitter, Input } from "@angular/core";
import { ResizeEvent } from "angular-resizable-element";

@Component({
  selector: "fields-determinant-edit",
  templateUrl: "./fields-determinant-edit.component.html",
})
export class FieldsDeterminantEditComponent {

  @Input() public serviceId: string;
  @Input() public componentKey: string;
  @Input() public determinantMapById: { [key: string]: string };
  @Output() public closeLayer: EventEmitter<any> = new EventEmitter();
  @Output() public changeDeterminants: EventEmitter<any> = new EventEmitter();
  public style: object = {};

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public closeSection() {
    this.closeLayer.emit();
  }
}
